module.exports = __webpack_public_path__ + "static/img/4.bcaafc1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/soft/4.jpg
// module id = CnK1
// module chunks = 13